export default __webpack_public_path__ + "static/media/me.0af01b5e.png";